import React, { useEffect, useState } from "react";
import { FormField } from "../FormField";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { executeLoginFetch, setErrorData, setPassword, setUsername } from "../../../../slices/loginFormSlice";
import { LoadingSpinner } from "../../../icons/LoadingSpinner";
import { urlParamValue } from "../../../../utils/utils";

export const LoginForm = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const { username, password } = useSelector((state) => state.login.loginForm);
    const { notAuthorized, isLoading, errorData } = useSelector((state) => state.login.loginFetch);
    const [isLoggedOut, setIsLoggedOut] = useState(false);
    const [isInactive, setIsInactive] = useState(false);
    const isBeta = String(process.env.REACT_APP_IS_BETA).toLowerCase() === 'true';

    useEffect(() => {
        setIsLoggedOut(Boolean(urlParamValue("logout")));
        setIsInactive(Boolean(urlParamValue("inactive")));
    }, []);

    const togglePasswordVisibility = () => {
        setIsPasswordVisible((prevState) => !prevState);
    };

    const handleSignIn = (e) => {
        e.preventDefault();
        dispatch(setErrorData(null));
        dispatch(executeLoginFetch());
    };

    const renderMessage = () => {
        if (errorData?.message === 'notActivated') {
            return notActivatedMsg();
        } else if (errorData?.message === 'accountInactive') {
            return validationFail(t('userIsInactive'))
        } else if (notAuthorized) {
            return validationFail(t('invalidCredentials'));
        } else if (errorData?.error) {
            return validationFail(errorData.error);
        } else if (isLoggedOut) {
            return logoutSuccess(t('logoutSuccess'));
        } else if (isInactive) {
            return logoutSuccess(t('inactivityLogoutSuccess'));
        }
        return null;
    }

    const notActivatedMsg = () => {
        return (
            <p className={'login-validation-msg'}>
                {t('accountNotActivated')}
                <a href={'/password-recovery'}>
                    {t('resendActivationLink')}
                </a>
            </p>
        );
    }

    const validationFail = (message) => {
        return (
            <p className={'login-validation-msg'}>
                {message}
            </p>
        );
    }

    const logoutSuccess = message => {
        return (
            <p className={'logout-success-msg'}>
                {message}
            </p>
        );
    }

    return (
        <div className={'main-page-dialog'}>
            <h3 className={'register-header'}>{t('signIn')}</h3>
            <h4 className={'register-subheader'}>{t('signInSub')}</h4>
            <form className={'main-page-login-form'}>
                <FormField type={'email'}
                    placeholder={t('typeEmail')}
                    name={'username'}
                    value={username}
                    changeHandler={(e) => dispatch(setUsername(e.target.value))} />
                <FormField type={'password'}
                    placeholder={t('typePassword')}
                    name={'password'}
                    value={password}
                    toggler={togglePasswordVisibility}
                    visible={isPasswordVisible}
                    changeHandler={(e) => dispatch(setPassword(e.target.value))} />
                <button className={'form-submit-button'}
                    onClick={handleSignIn}>
                    {isLoading ? <LoadingSpinner buttonMode={true} /> : t('logInButton')}
                </button>
                {renderMessage()}
            </form>
            {isBeta && (
                <div className={'pass-reminder'}>
                    <span className={'pass-reminder-link'}>
                        <a href={'/password-recovery'}>{t('loginProblems')}</a>
                    </span>
                </div>
            )}
            {!isBeta && (
                <>
                    <div className={'login-else'}>
                        <span className={'login-else-line left'} />
                        <span>{t('or')}</span>
                        <span className={'login-else-line right'} />
                    </div>
                    <button className={'form-submit-button register-redirect'}
                        onClick={() => window.location.href = '/sign-up'}>
                        {t('signUp')}
                    </button>
                    <div className={'pass-reminder'}>
                        <span className={'pass-reminder-link'}>
                            <a href={'/password-recovery'}>{t('loginProblems')}</a>
                        </span>
                    </div>
                </>
            )}
        </div>
    );
}